import { useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function Nav() {
  const { content, lang, setLang, ui } = useSite();
  const [open, setOpen] = useState(false);

  const scrollTo = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  const links = [
    ["services", ui.services],
    ["gallery", ui.gallery],
    ["testimonials", ui.testimonials],
    ["contact", ui.contact],
  ];

  return (
    <header className="fixed inset-x-0 top-4 z-50 px-4">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 rounded-full border border-white/10 bg-navy/80 px-4 py-2 shadow-2xl backdrop-blur-xl">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3"
        >
          <img src={content.logo} alt="D'Best Cleaning Services" className="h-10 w-auto rounded-lg" />
          <span className="hidden font-display text-xl tracking-wider text-white sm:block">
            D'BEST <span className="text-volt">CLEANING</span>
          </span>
        </button>

        <nav className="hidden items-center gap-6 md:flex">
          {links.map(([id, label]) => (
            <button
              key={id}
              data-testid={`nav-${id}`}
              onClick={() => scrollTo(id)}
              className="text-sm font-medium text-slate-300 transition-colors hover:text-volt"
            >
              {label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <div className="flex overflow-hidden rounded-full border border-white/10" data-testid="nav-lang-toggle">
            {["es", "en"].map((l) => (
              <button
                key={l}
                data-testid={`nav-lang-${l}`}
                onClick={() => setLang(l)}
                className={`px-3 py-1.5 text-xs font-bold uppercase transition-colors ${
                  lang === l ? "bg-volt text-navy" : "text-slate-300 hover:text-white"
                }`}
              >
                {l}
              </button>
            ))}
          </div>
          <a
            data-testid="nav-phone-cta"
            href={`tel:${content.phone_href}`}
            className="hidden items-center gap-2 rounded-full bg-volt px-4 py-2 text-sm font-bold text-navy transition-colors hover:bg-volt-hover sm:flex"
          >
            <Phone size={15} /> {content.phone}
          </a>
          <button
            data-testid="nav-menu-toggle"
            onClick={() => setOpen(!open)}
            className="rounded-full p-2 text-white md:hidden"
            aria-label="Menú"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="mx-auto mt-2 max-w-7xl rounded-2xl border border-white/10 bg-navy/95 p-4 backdrop-blur-xl md:hidden" data-testid="nav-mobile-menu">
          {links.map(([id, label]) => (
            <button
              key={id}
              data-testid={`nav-mobile-${id}`}
              onClick={() => scrollTo(id)}
              className="block w-full rounded-lg px-4 py-3 text-left text-sm font-medium text-slate-200 hover:bg-navy-surface"
            >
              {label}
            </button>
          ))}
          <a href={`tel:${content.phone_href}`} className="mt-2 flex items-center justify-center gap-2 rounded-full bg-volt px-4 py-3 text-sm font-bold text-navy" data-testid="nav-mobile-phone-cta">
            <Phone size={15} /> {content.phone}
          </a>
        </div>
      )}
    </header>
  );
}
